/**
 * Fetcher Contract
 * @author ChenSi
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree.json';

export class FContract extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/contract/', '/lpg/admin/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取电子合同模板列表（合同模板列表）
    getContractTemplateList(data) {
        const url = this.spellURL('getContractTemplateList', 'member/ContractTemplateCurrent');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 预览电子合同模板（电子合同模板列表）
    getPreviewContractTemplate(data) {
        const url = this.spellURL('getPreviewContractTemplate', 'member/ContractTemplatePreview');
        const send = {
            ...this.transKeyName('underline', data || {}),
        };
        return this.post(url, send);
    }

    // 上传企业电子章 URL（合同模板编辑）
    getUploadSealURLSpell() {
        return this.spellURL('uploadContractTemplateSeal', 'member/ContractTemplateUploadSeal');
    }

    // 新增电子合同模板（电子合同模板列表）
    saveContractTemplate(data) {
        const url = this.spellURL('saveContractTemplate', 'member/ContractTemplateCreate');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 启用/停用电子合同模板（电子合同模板列表）
    saveContractTemplateStatus(data) {
        const url = this.spellURL('saveContractTemplateStatus', 'member/ContractTemplateSetStatus');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 删除电子合同模板（电子合同模板列表）
    saveDeleContractTemplate(data) {
        const url = this.spellURL('saveDeleContractTemplate', 'member/ContractTemplateDelete');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 电子合同签署记录列表（合同列表）
    getContractRecordList(data) {
        const url = this.spellURL('getContractRecordList', 'member/electronicContractList');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchContract = new FContract();
